import React from 'react';
import PanelLayout from '../PanelLayout';

function CommanderOfflineTableList() {
  return (
    <PanelLayout
      innerContainerMaxWidth={'xl'}
      subPages={[
        {
          name: 'Commander Offline',
          url: '',
        },
      ]}
      title="Commander Offline"
    >
      <p>Commander Offline Table List</p>
    </PanelLayout>
  );
}

export default CommanderOfflineTableList;
